/*
 * @Desc: 首页 接口的统一出口
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-07-16 18:33:56
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = "/api/";

const index = {
    // 首页banner
    banner(params) {
        return axios.get(api + "gw/banner", { params: params });
    },
    // 获取所有一级栏目
    gwCate(params) {
        return axios.get(api + "gw/cate", { params: params });
    },
    // 首页新闻
    homeArticle(params) {
        return axios.get(api + "gw/homeArticle", { params: params });
    },
    // 新闻列表
    articleList(params) {
        return axios.get(api + "gw/articleList", { params: params });
    },
    // 文章详情
    articleDetail(params) {
        return axios.post(api + "gw/articleDetail", qs.stringify(params));
    },
    // 最新动态
    newArticle(params) {
        return axios.get(api + "gw/newArticle", { params: params });
    },
    // 获取网站配置
    getConfig(params) {
        return axios.get(api + "gw/config", { params: params });
    },
    // 报名--所有下拉选
    applySelect(params) {
        return axios.get(api + "apply/select", { params: params });
    },
    // 报名--提交
    applySubmit(params) {
        return axios.post(api + "apply/submit", qs.stringify(params));
    },
    // 报名--修改
    applyEdit(params) {
        return axios.post(api + "apply/edit", qs.stringify(params));
    },
    // 报名--详情
    applyDetail(params) {
        return axios.post(api + "apply/detail", qs.stringify(params));
    },
    // 提交反馈意见
    feedback(params) {
        return axios.post(api + "gw/suggest", qs.stringify(params));
    },
    // 栏目详情
    cateDetail(params) {
        return axios.get(api + "gw/cateDetail", { params: params });
    },
    // 全局搜索
    search(params) {
        return axios.get(api + "gw/search", { params: params });
    },
    // 友情链接
    link(params) {
        return axios.get(api + "gw/link", { params: params });
    },
    // 创建支付订单
    orderCreate(params) {
        return axios.post(api + "order/create", qs.stringify(params));
    },
    // PC支付
    pcPay(params) {
        return axios.post(api + "order/pcPay", qs.stringify(params));
    },
    // yjApplySelect  应届生报名所有下拉
    yjApplySelect(params) {
        return axios.get(api + "yjApply/select", { params: params });
    },
    // 应届生报名 获取市,区县 根据父级ID
    yjApplyAreas(params) {
        return axios.get(api + "yjApply/areas", { params: params });
    },
    // 应届生报名提交
    yjApplySubmit(params) {
        return axios.post(api + "yjApply/submit", qs.stringify(params));
    },
    // 修改应届生报名
    yjApplyEdit(params) {
        return axios.post(api + "yjApply/edit", qs.stringify(params));
    },
    // 应届生报名详情
    yjApplyDetail(params) {
        return axios.post(api + "yjApply/detail", qs.stringify(params));
    },
};

// 导出接口
export default index;
